<div class="chat-view-container">



     <!-- If the link is expired -->
     <!-- <div *ngIf="isLinkExpired" class="expired-link-message">
          <p>Sorry, this interview link has expired. Please create a new interview.</p>
     </div> -->
     <div *ngIf="isLinkExpired" class="expired-link-container"
          style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:80vh;">
          <mat-icon style="font-size:64px;color:#f7971e;margin-bottom:24px;">link_off</mat-icon>
          <h1 style="margin-bottom:12px;font-size:2.2rem;font-weight:600;color:#333;text-align:center;">Your link has
               expired</h1>
          <p style="font-size:1.25rem;color:#666;text-align:center;margin-bottom:24px;">Please contact admin to create a
               new Interview link.</p>
          <!-- <button mat-raised-button color="primary" style="font-size:1rem;padding:10px 32px;border-radius:8px;">Create New Interview</button> -->
     </div>
     <!-- If the link is valid, show chat messages -->
     <div *ngIf="!isLinkExpired">
          <div class="main-header">
               <div class="logo-section">
                    <div class="logo-icon">
                         <mat-icon>chat</mat-icon>
                    </div>
                    <span class="app-name">Otter AI</span>
               </div>
               <!-- Expired link message -->

               <mat-icon class="menu-toggle-btn" (click)="menuOpen = !menuOpen"
                    aria-label="Toggle menu">more_vert</mat-icon>
               <!-- Interview code and live mode only for active links -->

               <div class="toggle-menu-items" *ngIf="menuOpen" [class.show]="menuOpen">
                    <div class="zoom-controls">
                         <button class="zoom-btn" (click)="onZoomIn()">+</button>
                         <button class="zoom-btn" (click)="onZoomOut()">−</button>
                    </div>

                    <div class="interview-code mt-2">
                         <span>Interview Code:</span>
                         <span class="code">{{ templateId }}</span>
                    </div>

                    <div class="action-buttons mt-2">
                         <div class="interview-mode d-flex align-items-center">
                              <span class="mode">Live Interview mode</span>
                         </div>
                    </div>
               </div>
               <div *ngIf="!menuOpen" class="zoom-controls desktop-only">
                    <button class="zoom-btn" (click)="onZoomIn()">+</button>
                    <button class="zoom-btn" (click)="onZoomOut()">−</button>
               </div>
               <div *ngIf="!menuOpen" class="interview-code desktop-only">
                                                  <span>Interview Code:</span>
                                                  <span class="code">{{ templateId }}</span>
                                    </div>

                                    <!-- Custom Auto-scroll toggle and dropdown (no Material) -->
                                    <div class="auto-scroll-chip" style="display: flex; align-items: center; gap: 10px; margin-left: 18px;">
                                        <label class="custom-chip" style="background: #f4f8ff; color: #2a3a5e; font-weight: 500; border-radius: 16px; padding: 6px 16px; box-shadow: 0 2px 8px rgba(44,62,80,0.08); display: flex; align-items: center; gap: 10px; cursor: pointer;">
                                            <input type="checkbox" [(ngModel)]="autoScrollEnabled" (change)="onAutoScrollToggle()" style="accent-color: #1976d2; width: 18px; height: 18px; margin-right: 8px;">
                                            <span style="font-size: 1rem;">Auto Scroll</span>
                                            <span *ngIf="autoScrollEnabled" style="margin-left: 10px;">
                                                <select [(ngModel)]="autoScrollIntervalSeconds" (change)="onAutoScrollIntervalChange()" style="border-radius: 8px; border: 1px solid #bcd; background: #fff; color: #2a3a5e; font-weight: 500; padding: 4px 10px; font-size: 0.95rem; outline: none; box-shadow: 0 1px 4px #e0e7ef;">
                                                    <option *ngFor="let sec of autoScrollOptions" [value]="sec">{{sec}}s</option>
                                                </select>
                                            </span>
                                        </label>
                                    </div>

                                    <span class="spacer"></span>

                                    <div *ngIf="!menuOpen" class="action-buttons desktop-only">
                    <div class="interview-mode d-flex align-items-center">
                         <span class="mode">Live Interview mode</span>
                    </div>
               </div>
               <ng-container *ngIf="!isLinkExpired"></ng-container>
          </div>



          <div>
               <div class="chat-messages-container" #scrollContainer #zoomContainer (scroll)="onScroll()">
                    <!-- <div *ngIf="!(currentConversation$ | async)" class="welcome-screen"></div>

                    <div *ngFor="let msg of (currentConversation$ | async)?.messages" class="message-wrapper"
                         [ngClass]="msg.sender">
                         <div class="message-card">
                              <div class="message-header">
                                   <mat-icon class="chat-icon">{{ msg.sender === 'bot' ? 'chat' : 'group' }}</mat-icon>
                                   <p class="sender-label">{{ msg.sender === 'bot' ? 'Otter AI' : 'You' }}</p>
                                   <p class="msg-time">{{ msg.timestamp | date : "MMM d, y, h:mm a" }}</p>
                                   <mat-icon class="mat-icon-copy" [class.animate-copied]="msg.copied"
                                        (click)="copyToClipboard(msg)"
                                        matTooltip="{{ msg.copied ? 'Copied!' : 'Copy link' }}">
                                        {{ msg.copied ? 'check_circle' : 'content_copy' }}
                                   </mat-icon>
                              </div>
                              <div class="message-body" [innerHTML]="formatMessage(msg.text)"></div>
                         </div>
                    </div> -->
                      <ng-container *ngIf="currentConversation$ | async as conv">
                      <div *ngIf="conv.messages.length === 0" class="no-history-message" style="text-align:center;padding:48px 0;color:#888;font-size:1.2rem;">
                        <!-- <mat-icon style="font-size:48px;color:#bdbdbd;margin-bottom:12px;">chat_bubble_outline</mat-icon> -->
                        <div>There is no chat history yet.</div>
                      </div>
                      <div *ngFor="let msg of conv.messages" class="message-wrapper" [ngClass]="msg.sender">
                        <div class="message-card">
                          <div class="message-header">
                            <mat-icon class="chat-icon">{{ msg.sender === 'bot' ? 'chat' : 'group' }}</mat-icon>
                            <p class="sender-label">{{ msg.sender === 'bot' ? 'Otter AI' : 'You' }}</p>
                            <p class="msg-time">{{ msg.timestamp | date : 'MMM d, y, h:mm a' }}</p>
                            <mat-icon class="mat-icon-copy" [class.animate-copied]="msg.copied"
                              (click)="copyToClipboard(msg)"
                              matTooltip="{{ msg.copied ? 'Copied!' : 'Copy link' }}">
                              {{ msg.copied ? 'check_circle' : 'content_copy' }}
                            </mat-icon>
                          </div>
                          <div class="message-body" [innerHTML]="formatMessage(msg.text)"></div>
                        </div>
                      </div>
                    </ng-container>
                    <!-- Scroll-to-bottom arrow: visible when not near bottom -->
                    <!-- Hide scroll-to-bottom button while auto-scroll is active -->
                    <button class="scroll-to-bottom-btn chatgpt-arrow" 
                         [class.hidden-arrow]="isNearBottom || autoScrollAnimating"
                         (click)="onScrollToBottomClick()" [class.streaming]="isStreaming" title="Scroll to bottom">
                         <!-- use a more prominent double-arrow icon like ChatGPT -->
                         <mat-icon>arrow_downward</mat-icon>
                    </button>
               </div>
               <div class="zoom-indicator" *ngIf="showZoomIndicator" title="Click to reset zoom" style="position: absolute; top: 8px; right: 16px;
                background: rgba(0,0,0,0.7); color: white;
                padding: 6px 12px; border-radius: 6px; cursor: pointer; user-select: none; z-index: 1000;">
                    Zoom: {{ zoomDisplayValue }}
               </div>
          </div>
     </div>

     <style>
          .attachment-preview-card button mat-icon:hover {
               color: #e53935 !important;
          }

          .expired-link-message {
               text-align: center;
               font-size: 1.5rem;
               color: #ff5722;
               margin-top: 20px;
          }

          /* Chat messages container needs extra bottom padding to avoid collision with scroll-to-bottom button */
          .chat-messages-container {
               padding-bottom: 18rem; /* Prevents collision with scroll-to-bottom button */
          }

          /* Scroll-to-bottom button */
          .scroll-to-bottom-btn {
               position: fixed;
               right: 18px;
               bottom: 20px;
               z-index: 1200;
               background: transparent;
               border: none;
               padding: 0;
               cursor: pointer;
          }

          /* ChatGPT-like circular button */
          .chatgpt-arrow {
               width: 44px;
               height: 44px;
               border-radius: 22px;
               display: flex;
               align-items: center;
               justify-content: center;
               background: #0078d4;
               color: white;
               box-shadow: 0 6px 18px rgba(20, 45, 85, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);
               transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease, visibility 160ms ease;
               opacity: 1;
               visibility: visible;
          }

          /* Hide arrow smoothly without DOM manipulation to prevent flickering */
          .chatgpt-arrow.hidden-arrow {
               opacity: 0;
               visibility: hidden;
               pointer-events: none;
          }

          .chatgpt-arrow mat-icon {
               font-size: 26px;
          }

          /* Slight lift on hover */
          .chatgpt-arrow:hover {
               transform: translateY(-4px);
               box-shadow: 0 10px 24px rgba(20, 45, 85, 0.32);
          }

          /* Pulse while streaming */
          .chatgpt-arrow.streaming {
               animation: chat-pulse 1.6s infinite;
          }

          @keyframes chat-pulse {
               0% {
                    box-shadow: 0 6px 18px rgba(20, 45, 85, 0.25);
                    transform: scale(1);
               }

               50% {
                    box-shadow: 0 12px 30px rgba(20, 45, 85, 0.18);
                    transform: scale(1.06);
               }

               100% {
                    box-shadow: 0 6px 18px rgba(20, 45, 85, 0.25);
                    transform: scale(1);
               }
          }
     </style>